RivalIQ.apps.Insights.module('data', function (data, App, Backbone, Marionette, $, _) {

    'use strict';

    const FacebookInsightsPostDetailsCacheLayer = RivalIQ.data.CacheLayer.extend({
        name: 'FacebookInsightsPostDetails',

        Model: App.models.PostDetail,

        cacheKeys: [
            'companyId',
            'channel',
            'objectType', // NOTE reels have unique identity domain
            'postId'
        ],

        loadData: function (attributes) {
            const me = this;

            const model = new me.Model();

            attributes.reset = true;
            const pathParams = ['companyId', 'channel', 'objectType', 'postId', 'landscapeId'];
            _.extend(model, _.pick(attributes, pathParams));

            return model.fetch();
        },

        fetch: function (params) {
            const me = this;

            const def = me.getOrLoad(params);
            return def;
        }
    });


    data.facebookInsightsPostDetails = new FacebookInsightsPostDetailsCacheLayer();

});
